












import {Component, Vue} from 'vue-property-decorator'
import AppFooter from '@/components/footer/AppFooter.vue'
import Navbar from '@/components/navbar/Navbar.vue'
import TermsAndConditionsHeader from '@/components/termsAndConditions/TermsAndConditionsHeader.vue'
import TermsAndConditionsContent from '@/components/termsAndConditions/TermsAndConditionsContent.vue'
import {MetaInfo} from 'vue-meta'

@Component({
  components: {
    AppFooter,
    Navbar,
    TermsAndConditionsHeader,
    TermsAndConditionsContent,
  },
})
export default class TermsAndConditionsView extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: this.$translate('metadata.title.termsAndConditions'),
    }
  }

  mounted() {
    window.scrollTo(0, 0)
  }
}
